"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pipeline_1 = __importDefault(require("../pipeline"));
const features_1 = require("./features");
const layers_1 = require("./layers");
const style_1 = require("./style");
const default_1 = require("./default");
const analysis_1 = require("./analysis");
const user_1 = require("./user");
const fiberpaths_1 = require("./fiberpaths");
const plans_1 = require("./plans");
const nonBranchingPaths_1 = require("./nonBranchingPaths");
const otdrBreakpoint_1 = require("./otdrBreakpoint");
const address_1 = require("./address");
const sharedViews_1 = require("./sharedViews");
function casingPipeline(reassignFeatureAttributes = false) {
    const casing = (0, pipeline_1.default)();
    casing.add({
        doIf: (resp) => resp.config.url === '/v2/search' && ['get', 'post'].includes(resp.config.method || ''),
        action: features_1.processSearchFeatures,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/features\/inheritance\/.*$/.test(resp.config.url || ''),
        action: (resp) => (0, features_1.processInheritanceParents)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => /^\/v2\/features\/.*\/nesting$/.test(resp.config.url || ''),
        action: (resp) => (0, features_1.processNestedFeatures)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => /^\/v2\/features\/.*\/fill-ratio$/.test(resp.config.url || ''),
        action: default_1.processDefault,
    });
    casing.add({
        doIf: (resp) => resp.config.url === '/network/stored_fiberpath_types',
        action: fiberpaths_1.processStoredFiberpathTypes,
    });
    casing.add({
        doIf: (resp) => /^\/network\/stored_fiberpaths\/\d+$/.test(resp.config.url || ''),
        action: fiberpaths_1.processStoredFiberpaths,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').indexOf('/network/edit_fiberpaths') === 0 &&
            resp.config.method === 'get',
        action: fiberpaths_1.processWipFiberpaths,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').indexOf('/v2/network/non_branching_paths') === 0,
        action: nonBranchingPaths_1.processNonBranchingPaths,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').indexOf('/v2/network/otdr/break_location') === 0,
        action: otdrBreakpoint_1.processOtdrBreakpoint,
    });
    casing.add({
        doIf: (resp) => resp.config.url === '/v2/features/pre_update' ||
            (resp.config.url || '').indexOf('/v2/features/pre_merge') === 0,
        action: (resp) => (0, features_1.processPreUpdateFeatures)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('/v2/features/split'),
        action: (resp) => (0, features_1.processSplitFeatures)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('/v2/features') &&
            !(resp.config.url || '').includes('/v2/features/length') &&
            !(resp.config.url || '').includes('/v2/features/count') &&
            !(resp.config.url || '').includes('/v2/features/attributes') &&
            !(resp.config.url || '').includes('/v2/features/move') &&
            !(resp.config.url || '').includes('/v2/features/copy') &&
            !(resp.config.url || '').includes('v2/features/intersection/children') &&
            resp.config.method !== 'delete',
        action: (resp) => (0, features_1.processFeatures)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('/v2/integrations/external_features/get'),
        action: (resp) => (0, features_1.processExternalFeatures)(resp, reassignFeatureAttributes),
    });
    casing.add({
        doIf: (resp) => resp.config.url === '/v2/layers' && resp.config.method === 'get',
        action: layers_1.processLayers,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/layers\/layer\/\d+$/.test(resp.config.url || '') && resp.config.method === 'get',
        action: layers_1.processLayer,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/layers\/.*\/(style|behavior)$/.test(resp.config.url || '') &&
            resp.config.method === 'patch',
        action: style_1.processStyleUpdate,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('/v2/analysis') &&
            (resp.config.url || '').includes('source_feature_data'),
        action: analysis_1.processAnalysis,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('/v2/user'),
        action: user_1.processUser,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/style\/theme\/\d+\/styles$/.test(resp.config.url || ''),
        action: style_1.processStyleFetch,
    });
    casing.add({
        doIf: (resp) => ((resp.config.url || '').includes('/v2/analysis') &&
            !(resp.config.url || '').includes('route_to_network')) ||
            (resp.config.url || '').includes('/v2/features/attributes'),
        action: default_1.doNothing,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/plans\/\d+\/feature_count_by_layer$/.test(resp.config.url || ''),
        action: plans_1.processPlanFeatureCount,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/address\/search\/.*$/.test(resp.config.url || ''),
        action: address_1.processAddressSearch,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/address\/geocode\/.*$/.test(resp.config.url || ''),
        action: address_1.processAddressGeocode,
    });
    casing.add({
        doIf: (resp) => /^\/v2\/shared_views\/views\/.*$/.test(resp.config.url || ''),
        action: sharedViews_1.processSharedViewGetConfig,
    });
    casing.add({
        doIf: (resp) => (resp.config.url || '').includes('v2/features/intersection/children'),
        action: features_1.processGetIntersectingChildren,
    });
    casing.add({
        doIf: () => true,
        action: default_1.processDefault,
    });
    return casing;
}
exports.default = casingPipeline;
//# sourceMappingURL=index.js.map